export const isAllDayGuest = (invitedTo) => invitedTo === 'All day';

export const buildVenueAddress = (venueName, address) => {
    const parts = [
        venueName,
        address?.line1,
        address?.addressLine1,
        address?.line2,
        address?.addressLine2,
        address?.town || address?.city,
        address?.county || address?.state,
        address?.postcode || address?.postalCode,
        address?.country,
    ]
        .map((part) => (typeof part === 'string' ? part.trim() : part))
        .filter(Boolean);

    return parts.join(', ');
};

export const getCeremonyVenueText = (wedding) =>
    buildVenueAddress(wedding?.weddingVenue, wedding?.weddingVenueAddress);

export const getReceptionVenueText = (wedding) => {
    if (wedding?.sharedVenue === true) {
        return getCeremonyVenueText(wedding);
    }
    return buildVenueAddress(wedding?.weddingReception, wedding?.weddingReceptionAddress);
};

export const getTimeOfDaySuffix = (time, isEveningGuest = false) => {
    if (!time) return '';
    const hour = parseInt(time.split(':')[0], 10);
    if (Number.isNaN(hour)) return '';
    if (isEveningGuest || hour >= 17) return 'in the evening';
    if (hour < 12) return 'in the morning';
    return 'in the afternoon';
};

export const showMealChoicesForGuest = (invitedTo, wedding) =>
    isAllDayGuest(invitedTo) && wedding?.hideMeals !== true;

export const getRsvpDisplayModel = (wedding, invitedTo) => {
    const allDay = isAllDayGuest(invitedTo);
    const sharedVenue = wedding?.sharedVenue === true;
    const ceremonyVenue = getCeremonyVenueText(wedding);
    const receptionVenue = getReceptionVenueText(wedding);

    if (allDay) {
        return {
            inviteLabel: 'wedding',
            startTime: wedding?.weddingStartTime || '',
            isEveningGuest: false,
            showMealChoices: showMealChoicesForGuest(invitedTo, wedding),
            heroVenueText: ceremonyVenue,
            showReceptionToFollow: true,
            showReceptionInFinerDetails: !sharedVenue && Boolean(receptionVenue),
            finerDetailsReceptionText: receptionVenue,
            combineDateAndTime: false,
        };
    }

    const heroVenue = sharedVenue ? ceremonyVenue : (receptionVenue || ceremonyVenue);

    return {
        inviteLabel: 'reception',
        startTime: wedding?.receptionStartTime || '',
        isEveningGuest: true,
        showMealChoices: false,
        heroVenueText: heroVenue,
        showReceptionToFollow: false,
        showReceptionInFinerDetails: false,
        finerDetailsReceptionText: '',
        combineDateAndTime: true,
    };
};
